export class LengthConverter {
    public convert(amount: number, from: LengthUnit, to: LengthUnit) {
        const fromFactor = this.unitInMilliMeter(from)
        const toFactor = this.unitInMilliMeter(to)
        return amount * fromFactor / toFactor
    }

    private unitInMilliMeter (unit: LengthUnit) {
        switch (unit) {
            case "mm": return 1
            case "cm": return 10
            case "dm": return 100
            default: return 1000
        }
    }
}
